import type {ReactElement} from 'react';
import React from 'react';
import {ContextualMenuSliderOptions} from '@Components/contextual-menu/components/contextual-menu-slider-options';
import {MAX_STROKE_WIDTH, MIN_STROKE_WIDTH} from '@PosterWhiteboard/classes/text-styles.class';

const MIN_STROKE_DISPLAY_WIDTH = 0;
const MAX_STROKE_DISPLAY_WIDTH = 100;

interface BaseTextStrokeWidthOptionProps {
  strokeWidth: number;
  className?: string;
  onUpdateStrokeWidth(strokeWidth: number, undoable?: boolean): void;
}

export function BaseTextStrokeWidthOption({className = '', ...props}: BaseTextStrokeWidthOptionProps): ReactElement<any> {
  const onChangeStrokeThickness = (updatedValue: number): void => {
    props.onUpdateStrokeWidth(updatedValue, false);
  };

  const onChangeStrokeThicknessEnded = (updatedValue: number): void => {
    props.onUpdateStrokeWidth(updatedValue);
  };
  return (
    <ContextualMenuSliderOptions
      id="item-outline-thickness-option"
      className={className}
      value={props.strokeWidth}
      label={window.i18next.t('pmwjs_thickness')}
      range={{
        min: MIN_STROKE_WIDTH,
        max: MAX_STROKE_WIDTH,
      }}
      transformDisplay={{
        min: MIN_STROKE_DISPLAY_WIDTH,
        max: MAX_STROKE_DISPLAY_WIDTH,
      }}
      onChange={onChangeStrokeThickness}
      onChangeEnded={onChangeStrokeThicknessEnded}
    />
  );
}
